import { createCanBoundTo } from '@casl/react';
import ability from '../../util/ability';

export default createCanBoundTo(ability);
